import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'dual-screen', 'DualScreen', [["path",{"d":"M5 4l8 3v15l-8 -3l0 -15"}],["path",{"d":"M13 19h6v-15h-14"}]]);